<template>
  <div class="proxylong">
    <banner :swiperData="swiperData" :pagination="false" />
    <div class="main">
      <tabs :tabsList="tabsList" />
      <div
        class="tabs-content width1534"
        :style="{ 'border-color': tabsList[active].color }"
      >
        <longFamily :active="active" />
      </div>
    </div>
  </div>
</template>

<script>
import banner from "@/components/banner";
import tabs from "@/components/tabs";
import longFamily from "@/components/long/index";
export default {
  name: "proxylong",
  components: { banner, tabs, longFamily },
  data() {
    return {
      swiperData: [
        {
          title: "多贝云家庭住宅代理",
          content: "基于运营商一手线路资源 --- 真实家庭住宅IP",
          descript: [
            "延迟毫秒级别",
            "完全自建节点",
            "便捷易用",
            "高效稳定纯净",
          ],
          btn: [
            {
              icon: require("@/assets/images/banner_icon3.png"),
              text: "免费咨询",
              route: "#",
            },
            {
              icon: require("@/assets/images/banner_icon4.png"),
              text: "立即试用",
              route: "#",
            },
          ],
          imgUrl: require("@/assets/images/banner4.jpg"),
          mimgUrl: require("@/assets/images/mbanner4.jpg"),
        },
      ],
      tabsList: [
        {
          color: "#27a7e7",
          title: "产品简介",
          en: "Product Introduction",
          icon: require("@/assets/images/icon5.png"),
          icon_active: require("@/assets/images/icon1.png"),
        },
        {
          color: "#f78834",
          title: "套餐购买",
          en: "Package purchase",
          icon: require("@/assets/images/icon6.png"),
          icon_active: require("@/assets/images/icon2.png"),
        },
        {
          color: "#1da83b",
          title: "提取IP/生成IP",
          en: "Extract IP/Generate IP",
          icon: require("@/assets/images/icon7.png"),
          icon_active: require("@/assets/images/icon3.png"),
        },
        {
          color: "#004cba",
          title: "常见问题",
          en: "frequently asked question",
          icon: require("@/assets/images/icon8.png"),
          icon_active: require("@/assets/images/icon4.png"),
        },
      ],
      active: 0,
    };
  },
  created() {
    this.$bus.$on("tabsEvent", (res) => {
      this.active = res;
    });
  },
};
</script>

<style lang="less" scoped>
.proxylong {
  .main {
    margin: 56px 0 110px;
  }
  .tabs-content {
    border: 9px solid transparent;
  }
}
@media (max-width: 1024px) {
  .proxylong .tabs-content {
    border: 4px solid transparent;
  }
}
</style>
